import React, { useState } from 'react'
import ChevronUpIconPurple from '../../assets/images/Chevron_up.png'
import ChevronDownIconPurple from '../../assets/images/Chevron_Down.png'
import Text from '../Text'
import classNames from 'classnames'

const Accordion = ({
  title,
  answer,
  answerContent,
  index,
  downIcon = ChevronDownIconPurple,
  upIcon = ChevronUpIconPurple,
  chevronIcon,
  styles = {
    bg: '#F2F2F2',
    titleColor: '#8077B7',
    answerColor: '#5A6774',
  },
}) => {
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [accordionClick, setAccordionClick] = useState(false)
  const [activeQues, setActiveQues] = useState(null)
  const ChevronCustomIcon = chevronIcon || null

  return (
    <>
      <div
        className="p-[16px] border-1 rounded-2xl mt-[16px]"
        style={{
          backgroundColor: styles.bg,
        }}
      >
        <div
          onClick={() => {
            setAccordionClick(true)
            setAccordionOpen(!accordionOpen)
            setActiveQues(index)
          }}
          className="flex justify-between w-full"
        >
          <Text
            tag="p"
            variant="title"
            size="medium"
            className="font-[600] text-left"
            style={{
              color: styles.titleColor,
            }}
          >
            {title}
          </Text>
          {ChevronCustomIcon ? (
            <ChevronCustomIcon
              color={styles.titleColor}
              className={classNames(
                'w-8 h-8 block flex-shrink-0',
                'transition-transform duration-200 ease-in-out',
                'origin-center',
                accordionOpen ? 'rotate-0' : 'rotate-180',
              )}
            />
          ) : (
            <img
              src={
                accordionOpen
                  ? downIcon
                  : index === activeQues && !accordionClick
                    ? downIcon
                    : upIcon
              }
              className="w-[50px] h-[50px]"
            />
          )}
        </div>
        {accordionOpen ? (
          <div
            className={`grid mt-3 overflow-hidden transition-all duration-300 ease-in-out text-slate-600 ${
              accordionOpen
                ? 'grid-rows-[1fr] opacity-100'
                : index === activeQues && !accordionClick
                  ? 'grid-rows-[1fr] opacity-100'
                  : 'grid-rows-[0fr] opacity-0'
            }`}
          >
            {answerContent ? (
              answerContent
            ) : (
              <Text
                tag="p"
                variant="body"
                size="large"
                className="overflow-hidden font-[300]"
                style={{
                  color: styles.answerColor,
                }}
                dangerouslySetInnerHTML={{ __html: answer }}
              />
            )}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default Accordion
